module.exports = __webpack_public_path__ + "static/media/19ESCAP21.5be3ee2e.jpg";